import { put, call, take, fork } from 'redux-saga/effects'
import { deleteCollectionCollaboratorService } from 'src/api/collection'

import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'
import { DELETE_COLLECTION_COLLABORATOR } from 'src/reducers/collection/type'
import { deleteCollectionCollaboratorSuccess } from 'src/reducers/collection/action'
/**
 *
 * @param {*} payload
 */
function* deleteCollectionCollaboratorSagaFlow(payload) {
  try {
    const { id, userId, callback } = payload
    yield call(deleteCollectionCollaboratorService, id, userId)

    yield put(deleteCollectionCollaboratorSuccess(userId))
    yield put(operationSuccess())

    callback(id)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* deleteCollectionCollaboratorWatcher() {
  while (true) {
    const action = yield take(DELETE_COLLECTION_COLLABORATOR)
    const { payload } = action

    yield fork(generalSaga, deleteCollectionCollaboratorSagaFlow, payload)
  }
}
